const parametrizationMinimumBillingHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Id',
        id: 'empresa-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'empresa-nome',
        show: true
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'Id',
        id: 'fornecedor-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'fornecedor-nome',
        show: true
      }
    ]
  },
  {
    group: 'Faturamento Minimo',
    columns: [
      {
        name: 'Valor R$',
        id: 'faturamento-valor',
        show: true,
        isNumeric: true
      }
    ]
  }
]

export default parametrizationMinimumBillingHeader
